import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer,Highchartscomponent, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';



Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});



const skills = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'It is not an issue',
        data: [7, 18 ,8]
    },{
        name: 'It is somewhat an issue',
        data: [27, 29, 44]
    },{
        name: 'It is a major issue',
        data: [67, 54, 48]
    }]
}




export class ChapterFiftyOne extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>
        <TextHolder text="An incredible 90 percent of survey respondents believe the skills gap is a major issue for the tech industry. There is a great deal of tech talent in the region, but the workforce still needs more and stronger skills." />
        <TextHolder text="SyPhong Bui of OnOnPay said that science, technology, education and math education is strong across many SEA nations. “There is a good foundation for the development of regional tech talent. However, we need to better cultivate more abstract skills such as product-building, design, and market-execution skills which are best learned outside the classroom. Experienced entrepreneurs and investors must continue to facilitate or provide mentorship in these areas and demonstrate patience as their peers make mistakes and learn through experience.”" />
        <TextHolder text="Jimmy How of Involve Asia said that companies should get better at recognizing useful skillsets “outside the obvious… such as strong digital marketing talent or business process professionals.” However, he also noted that offering basic computer science courses in high schools and creating incentives for companies to provide training to employees could also help bolster technical skills." />

        <TextHolder text="" />


          <Highchartscomponent   chartsTitle="Skills gap" chartsText="How do you think the skills of available talent is viewed in the SEA tech industry in general?" options={skills} source="Source: 2018 State of SE Asian Tech Survey" />




          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/51.js